export const ID_OZON_SELLER_API_CONNECTION = 25;
